import { rest } from "msw";
import endpoints from "@src/core/api/endpoints";
import { BasePayload } from "@src/core/api/payload-mapper";
import { mockAddress } from "@src/core/mocks/models/address";
import { mockAsset } from "@src/core/mocks/models/asset";
import { mockCreator } from "@src/core/mocks/models/creator";
import { mockCustomer } from "@src/core/mocks/models/customer";
import { mockDrop } from "@src/core/mocks/models/drop";
import { mockOffer } from "@src/core/mocks/models/offer";
import { mockOrder } from "@src/core/mocks/models/order";
import * as dropSample from "@src/core/mocks/pilot";
import { mockList, mockSingle } from "@src/core/mocks/api/payloads";

export const makeGetHandler = (
  url: string,
  mock: () => BasePayload | BasePayload[]
) =>
  rest.get(url, (_request, response, context) => {
    return response(
      context.status(200),
      context.json({ body: { data: mock() } })
    );
  });

export const makePostHandler = (
  url: string,
  mock: () => BasePayload | BasePayload[]
) =>
  rest.post(url, (_request, response, context) => {
    return response(
      context.status(200),
      context.json({ body: { data: mock() } })
    );
  });

const addressesHandlers = [
  makeGetHandler(`${endpoints.addressFind(":id")}`, mockSingle(mockAddress)),
];

const assetsHandlers = [
  makeGetHandler(endpoints.assetsList(), mockList(mockAsset)),
  makeGetHandler(`${endpoints.assetsFind(":id")}`, mockSingle(mockAsset)),
];

const creatorHandlers = [
  makeGetHandler(`${endpoints.creatorFind()}`, mockSingle(mockCreator)),
];

const customerHandlers = [
  makeGetHandler(endpoints.customerFind(), mockSingle(mockCustomer)),
];

const dropsHandlers = [
  makeGetHandler(`${endpoints.dropsList()}`, mockList(mockDrop)),
];

const offersHandlers = [
  makeGetHandler(endpoints.offersListByDrop(":dropId"), mockList(mockOffer)),
  makeGetHandler(`${endpoints.offersFind(":id")}`, mockSingle(mockOffer)),
];

const ordersHandlers = [
  makeGetHandler(endpoints.ordersList(":wallet"), mockList(mockOrder)),
  makeGetHandler(`${endpoints.ordersFind(":id")}`, mockSingle(mockOrder)),
  makePostHandler(`${endpoints.ordersCreate()}`, mockSingle(mockOrder)),
];

const overrideHandlers = [
  makeGetHandler(
    endpoints.creatorFind(),
    mockSingle(() => dropSample.creator)
  ),
  makeGetHandler(`${endpoints.dropsList()}`, () => [
    mockSingle(() => dropSample.drop)(),
  ]),
  makeGetHandler(endpoints.offersListByDrop(dropSample.drop.id), () =>
    dropSample.offers.map((offer) => mockSingle(() => offer)())
  ),
  ...dropSample.offers.map((offer) =>
    makeGetHandler(
      `${endpoints.offersFind(offer.id)}`,
      mockSingle(() => offer)
    )
  ),
];

export const handlers = [
  // ...overrideHandlers,
  // ...addressesHandlers,
  // ...assetsHandlers,
  ...creatorHandlers,
  // ...customerHandlers,
  // ...dropsHandlers,
  // ...offersHandlers,
  // ...ordersHandlers,
];
